import apiRequest from "./apiRequest";

export const createPayment = async (orderId, token) => {
  const payment = await apiRequest.post(
    `v2/payments/${orderId}`,
    {},
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );

  return payment.data;
};
